import { Backdrop } from "common/components/Backdrop";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { createSelector } from "reselect";
import { useInterval } from "../../common/useIntervalHook";
import { IApplicationState } from "../../redux/root-reducer";
import { getAllMetersAction } from "../meter.actions";
import { MeterItem } from "./meterItem";

const getDomainSelector = createSelector(
  (state: IApplicationState) => state.common,
  (commonState) => ({
    domainCode: commonState.selectedDomain?.Code ?? "",
    phoneNumbers: commonState.currentUserInfo.PhoneNumbers as string[],
  })
);

const getMeters = createSelector(
  (state: IApplicationState) => state.meters,
  (meters) => ({
    meters: meters.meters,
    isFetching: meters.isFetching,
  })
);

const POLLINGINTERVALMS = 60000;

export const MeterListView = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id }: any = useParams();

  const { domainCode, phoneNumbers } = useSelector(getDomainSelector);
  const { meters, isFetching } = useSelector(getMeters);

  useInterval(() => {
    if (domainCode) {
      dispatch(getAllMetersAction(domainCode, id));
    }
  }, POLLINGINTERVALMS);

  return (
    <>
      {meters.map((m, i) => (
        <MeterItem
          domain={domainCode}
          meterObject={m}
          phoneNumbers={phoneNumbers}
          key={i}
        />
      ))}
      {meters.length === 0 && !isFetching && (
        <p>{t("There are no shell protection sensors in this apartment")}</p>
      )}
    </>
  );
};
